import React from "react";
import { Switch, Route } from "react-router-dom";
import TariffsPage from "./TariffsPage";
import TariffPage from "./TariffPage";

const Tariffs = () => (
  <Switch basepath="/finance/tariffs">
    <Route path="/finance/tariffs/:id">
      <TariffPage />
    </Route>
    <Route path="/finance/tariffs">
      <TariffsPage />
    </Route>
  </Switch>
);

export default Tariffs;
